<div class="side-panel__container">
  <div class="side-panel__title">
    <h2 class="fs__md fw__500">
      <ng-content select="[slot=title]"></ng-content>
    </h2>
    <eiq-button
      class="mat-side-panel-title__close"
      [title]="'Close Panel'"
      [color]="'light'"
      [style]="'icon'"
      [icon]="faClose"
      (clicked)="close.emit()"
    ></eiq-button>
  </div>
  <div class="side-panel__content">
    <ng-content select="[slot=content]"></ng-content>
  </div>

  <div class="side-panel__actions">
    <button mat-stroked-button (click)="close.emit()">Close</button>
    <ng-content select="[slot=action]"></ng-content>
  </div>
</div>
